import request from "../utils/request";

export function getNgayLe(params) {
  return request({
    url: "ngayle",
    method: "get",
    params,
  });
}

export function addNgayLe(data) {
  return request({
    url: "ngayle",
    method: "post",
    data,
  });
}

export function editNgayLe(data) {
  return request({
    url: "ngayle",
    method: "put",
    data,
  });
}

export function xoaNgayLe(data) {
  return request({
    url: "xoangayle",
    method: "put",
    data,
  });
}
